// Comprar agora: adiciona o item ao carrinho pelo mesmo endpoint que o tema usa
// (o action do formulario de produto = routes.cart_add_url, ciente do locale) e,
// em caso de sucesso, redireciona para a URL canonica do checkout (/checkout).
// Comportamento isolado do "Adicionar a sacola": nao mexe no fluxo do formulario.
class BuyNowButton extends HTMLElement {
  /** @type {HTMLButtonElement | null} */
  button = null;

  connectedCallback() {
    this.button = this.querySelector('button');
    this.button?.addEventListener('click', () => this.handleClick());
  }

  async handleClick() {
    if (!this.button || this.button.hasAttribute('disabled') || this.classList.contains('is-loading')) {
      return;
    }

    const form = /** @type {HTMLFormElement | null} */ (
      this.closest('form') || document.querySelector('product-form-component form')
    );
    const action = form?.getAttribute('action');
    if (!form || !action) return;

    this.classList.add('is-loading');

    try {
      const response = await fetch(action, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      const data = await response.json().catch(() => null);

      // Em erro (ex.: estoque acabou entre o carregamento e o clique) o Shopify
      // devolve um objeto com `status`; nesse caso nao redireciona.
      if (!response.ok || data?.status) {
        this.classList.remove('is-loading');
        return;
      }

      window.location.href = '/checkout';
    } catch {
      this.classList.remove('is-loading');
    }
  }
}

if (!customElements.get('buy-now-button')) {
  customElements.define('buy-now-button', BuyNowButton);
}
